import MobileDetect from 'mobile-detect';
import { useEffect, useState } from 'react';

const useDeviceType = (): string => {
  const [deviceType, setDeviceType] = useState<string>('desktop');

  useEffect(() => {
    const md = new MobileDetect(navigator.userAgent);
    if (md.tablet()) {
      setDeviceType('tablet');
    } else if (md.mobile()) {
      setDeviceType('mobile');
    }
  }, []);

  return deviceType;
};

export default useDeviceType;
